if (typeof jQuery !== "undefined") {
  (($) => {
    const containers = document.querySelectorAll(".image-gallery-container");

    containers.forEach((container) => {
      const $el = $(container).find(".image-gallery-container--item");
      try {
        $el.swipebox();
      } catch (ex) {}
    });
  })(jQuery);
}
